import './bootstrap';

import Alpine from 'alpinejs';
import dayjs from 'dayjs';
require('dayjs/locale/fr')
dayjs.locale('fr')

window.currency_symbols = {
    'USD': '$', // US Dollar
    'EUR': '€', // Euro
    'CRC': '₡', // Costa Rican Colón
    'GBP': '£', // British Pound Sterling
    'ILS': '₪', // Israeli New Sheqel
    'INR': '₹', // Indian Rupee
    'JPY': '¥', // Japanese Yen
    'KRW': '₩', // South Korean Won
    'NGN': '₦', // Nigerian Naira
    'PHP': '₱', // Philippine Peso
    'PLN': 'zł', // Polish Zloty
    'PYG': '₲', // Paraguayan Guarani
    'THB': '฿', // Thai Baht
    'UAH': '₴', // Ukrainian Hryvnia
    'VND': '₫', // Vietnamese Dong
};


window.Alpine = Alpine;

Alpine.start();

import { toggleModal } from './layout/modal';
window.toggleModal = toggleModal;

import './layout/loginform.js';
import './layout/registerform.js';
import './layout/share';
import './layout/auth/feed_list';
import './layout/product';
import './layout/cdf';
import './layout/pro_list_product';

import './layout/searchPublic';
